<div class="container">
  <lib-ad-sponsor-banner
    *ngIf="leagueService.getCurrentLeagueId()"
    [entityId]="leagueService.getCurrentLeagueId()"
    [entityType]="entityType"
    [hideHeader]="true">
  </lib-ad-sponsor-banner>
  <lib-picker-slider
    *ngIf="topTeams"
    [items]="topTeams"
    (onSelect)="onItemSelect($event)">
  </lib-picker-slider>
  <lib-content-card-list
    *ngIf="selectedItem"
    [item]="selectedItem"
    [newsType]="newsType">
  </lib-content-card-list>
</div>
